var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { BeaconOuter, BeaconInner } from "./styled";
var HIDE_AFTER_MS = 10000;
var CustomBeacon = /** @class */ (function (_super) {
    __extends(CustomBeacon, _super);
    function CustomBeacon() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showBeacon: true
        };
        _this.componentDidMount = function () {
            _this.timerHandler = setTimeout(function () {
                _this.setState({ showBeacon: false });
            }, HIDE_AFTER_MS);
        };
        _this.componentWillUnmount = function () {
            if (_this.timerHandler)
                clearTimeout(_this.timerHandler);
        };
        return _this;
    }
    CustomBeacon.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter;
        var showBeacon = this.state.showBeacon;
        return showBeacon ? (React.createElement(BeaconOuter, __assign({}, this.props, { onMouseEnter: onMouseEnter, onClick: onClick }),
            React.createElement(BeaconInner, null))) : (React.createElement("span", null));
    };
    return CustomBeacon;
}(PureComponent));
export default CustomBeacon;
